import { endpoints } from "config";

export const META_TITLE = "Rockstar Energy";
export const META_DESCRIPTION =
  "Keep that same energy with our offering of Rockstar Energy Products, made with delicious fruit flavored energy to keep you on your grind.";
export const CANONICAL_URL_BASE = endpoints.web;
export const META_DEFAULT_OG_IMAGE = `https://www.datocms-assets.com/74813/1659619796-cropped-favicon-192x192.webp`;
export const PRIMARY_COLOR = `#CF9C43`;
